import React from 'react';
import { Modal, Typography, Button } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import ReactGA from 'react-ga4';
import { white, transparentWhite } from '../../../app/theme';

interface Props {
  url: string;
  isOpen: boolean;
  handleModalOpen: (isOpen: boolean) => void;
}

const useStyles = makeStyles((theme: Theme) => ({
  modalContainer: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },
  modalBackground: {
    width: '33%',
    maxWidth: 680,
    backgroundColor: transparentWhite,
    padding: 24,
  },
  modal: {
    padding: '2em',
    position: 'relative',
    boxSizing: 'border-box',
    backgroundColor: white,
    wordBreak: 'break-word',
    '& a': {
      color: 'inherit',
    },
  },
  closeButton: {
    position: 'absolute',
    top: '0.25em',
    right: '0.25em',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '1em',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  button: {
    textTransform: 'uppercase',
    fontWeight: 'bold',
    fontSize: '0.75em',
    fontStyle: 'normal',
    letterSpacing: 0,
    borderRadius: 1000,
    marginRight: '1.5em',
    '& > *': {
      color: white,
    },
    '&:last-child': {
      marginRight: 0,
      marginBottom: 0,
    },
    [theme.breakpoints.down('md')]: {
      marginRight: 0,
      marginBottom: '1em',
    },
  },
}));

const ExternalLinkModal = ({ url, isOpen, handleModalOpen }: Props): JSX.Element => {
  const classes = useStyles();

  const handleClickExternalLink = (externalUrl: string) => {
    ReactGA.event({
      category: 'event',
      action: 'Outbound Link Click',
      label: externalUrl,
    });
    handleModalOpen(false);
  };

  return (
    <Modal open={isOpen} onClose={() => handleModalOpen(false)}>
      <div className={classes.modalContainer}>
        <div className={classes.modalBackground}>
          <div className={classes.modal}>
            <IconButton aria-label="close" className={classes.closeButton} onClick={() => handleModalOpen(false)}>
              <CloseIcon />
            </IconButton>
            <Typography gutterBottom>
              <strong>You are now leaving www.blueearthdxmedicalaffairshub.com.</strong>
            </Typography>
            <Typography gutterBottom>
              <strong>Do you wish to proceed?</strong>
            </Typography>
            <div className={classes.buttonContainer}>
              <Button
                className={classes.button}
                variant="contained"
                color="secondary"
                href={url}
                target="_blank"
                rel="noreferrer"
                onClick={() => handleClickExternalLink(url)}
              >
                Yes, I wish to proceed
              </Button>
              <Button
                className={classes.button}
                variant="contained"
                color="secondary"
                onClick={() => handleModalOpen(false)}
              >
                No, take me back
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ExternalLinkModal;
